import { observer } from 'mobx-react-lite';
/* tslint:disable:jsx-no-lambda WI:47690 */
import { owaSuiteHeaderRendered } from '../actions/owaSuiteHeaderRendered';
import { IO365ShellShim } from '@suiteux/suiteux-shell';
import '@suiteux/suiteux-shell';
import setAppPaneUnderlayVisibility from 'owa-application/lib/actions/setAppPaneUnderlayVisibility';
import { getBposNavBarData } from 'owa-bpos-store';
import { getPackageBaseUrl, getApp, isNative } from 'owa-config';
import { OpenAnotherMailboxDialog } from 'owa-explicit-logon';
import { getIsDarkTheme } from 'owa-fabric-theme';
import { isFeatureEnabled } from 'owa-feature-flags';
import { HEADER_BUTTONS_REGION_ID, OWA_SEARCH_SCOPE_PICKER_ID } from 'owa-header';
import { lazySignout } from 'owa-header';
import { getMergedNotificationPane } from 'owa-header/lib/components/getMergedNotificationPane';
import { lazyHandleSocPostMessageEvents } from 'owa-help-charm';
import loc from 'owa-localize';
import { feedbackLink } from 'owa-locstrings/lib/strings/feedbacklink.locstring.json';
import { helpLink } from 'owa-locstrings/lib/strings/helplink.locstring.json';
import { openAnotherMailbox } from 'owa-locstrings/lib/strings/openanothermailbox.locstring.json';
import { privacyLink } from 'owa-locstrings/lib/strings/privacylink.locstring.json';
import { reportCalendarAbuseLink } from 'owa-locstrings/lib/strings/reportcalendarabuselink.locstring.json';
import { termsLink } from 'owa-locstrings/lib/strings/termslink.locstring.json';
import { showModal } from 'owa-modal';
import { DEFAULT_COLLAPSED_WIDTH } from 'owa-search/lib/searchConstants';
import { getConfig } from 'owa-service/lib/config';
import WebSessionType from 'owa-service/lib/contract/WebSessionType';
import { isConsumer } from 'owa-session-store';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { logCalendarUsage } from 'owa-shared-analytics';
import { lazyInitializeOneNoteFeed } from 'owa-notes-feed-bootstrap';
import { isTimePanelAvailable } from 'owa-time-panel-bootstrap';
import { lazyInitializeTimePanel } from 'owa-time-panel';
import { lazyGetAccessTokenforResource } from 'owa-tokenprovider/lib/lazyFunctions';
import { getNewScope } from 'owa-url';
import { lazyLaunchInAppFeedback } from 'owa-uservoice';
import { initializeVaultInfoLazy } from 'owa-vault';
import OwaWorkload from 'owa-workloads/lib/store/schema/OwaWorkload';
import isWorkloadSupported from 'owa-workloads/lib/utils/isWorkloadSupported';
import { isSupportEnabled, lazyHandleSupportPaneEvents } from 'diagnostics-and-support';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { dispatch } from 'satcheljs';
import { resolve as urlResolve } from 'url';
import {
    lazyOnHideNotificationReceived,
    lazyOnNotificationReceived,
    addChatTab,
    isSkypeInTabsEnabled,
} from 'owa-skype';
import {
    getCurrentThemeId,
    isUserPersonalizationAllowed,
    getHeaderImageData,
    getPaletteAsRawColors,
    getCobrandingThemeResources,
} from 'owa-theme';
import { OwaPalette, ThemeConstants } from 'owa-theme-shared';
import {
    LinkClickEventArgs,
    SuiteHeader,
    NavBarData as ShellNavBarData,
    ShellLayout,
    CustomizationRegion,
    ShellControl,
    ThemeDataOverride,
    NavBarLinkData,
    SignOutEventArgs,
    FlexPaneChangeListenerProperties,
} from '@suiteux/suiteux-shell-react';
import {
    OwaWhatsNewButton,
    OwaRolloutOverridesButton,
    OwaFeedbackButton,
    OwaSupportButton,
    OwaSettingsButton,
    OwaShellHelpButton,
    OwaBusinessChatButton,
    OwaConsumerChatButton,
    OwaDiagnosticsButton,
    OwaActivityFeedButton,
    OwaPremiumButton,
    OwaTimePanelButton,
    OwaVaultButton,
    OwaNoteFeedButtonAds,
    OwaNoteFeedButtonPaid,
    OwaMeetNowButton,
    OwaInboxForMeButton,
} from './OwaSuiteHeaderButton';
import {
    OwaFeedbackFlexPane,
    OwaRolloutOverridesFlexPane,
    OwaSettingsFlexPane,
    OwaTimePanelFlexPane,
    OwaWhatsNewFlexPane,
    OwaHelpFlexPane,
    OwaSupportFlexPane,
    OwaActivityFeedFlexPane,
    OwaExpressionFlexPane,
    OwaSkypeFlexPane,
    OwaVaultFlexPane,
    OwaIdeasFlexPane,
    OwaNoteFeedFlexPane,
    OwaInboxForMeFlexPane,
} from './OwaSuiteFlexPane';
import { OwaActivityFeedButtonID, OwaWhatsNewButtonID, OwaFeedbackButtonID } from '../constants';
import { getUnseenItemsCount } from 'owa-activity-feed/lib/store/unseenItemsSelector';
import { setShellButtonCustomBadgeCount } from 'owa-suite-header-apis';
import { getUnreadWhatsNewCardCount } from 'owa-whats-new';
import { lazyInitializeSkypeForBusiness } from 'owa-skype-for-business';
import { useWindowEvent } from 'owa-react-hooks/lib/useWindowEvent';
import { lazyInitializeKnownIssuesPoll, lazyGetKnownIssuesBadgeCount } from 'owa-known-issues';
import { lazyIsMeetNowEnabled } from 'owa-meet-now';
import { BASE_LIGHT_THEME_PALETTE } from 'owa-theme-common';
import { getIsOfficeThemePreferred, getCurrentTheme } from 'owa-suite-theme';
import { isEnvironmentAirGap } from 'owa-metatags';
import { OwaSuiteHeaderProps } from 'owa-bootstrap';

interface ExtendedWindow {
    O365Shell: IO365ShellShim;
}

const isOutlookHosted = isNative();
declare var window: Window & ExtendedWindow;
const ShellMailId = 'ShellMail';

const APP_BRAND_THEME = generateSuitePaletteFromFabricPalette(BASE_LIGHT_THEME_PALETTE);
const OWA_APP_ID = '00000002-0000-0ff1-ce00-000000000000';
const OWA_CONSUMER_APP_ID = '292841';

export default observer(function OwaSuiteHeader(props: OwaSuiteHeaderProps) {
    React.useEffect(() => {
        if (isFeatureEnabled('fwk-skypeBusinessV2')) {
            lazyInitializeSkypeForBusiness.importAndExecute();
        }
        if (headerChatEnabled.current) {
            window.addEventListener('swc:core:ready', () => {
                onSwcCoreReady();
            });
        }
        if (isFeatureEnabled('fwk-feedbackCharm') && isFeatureEnabled('fwk-knownIssues')) {
            lazyInitializeKnownIssuesPoll.importAndExecute();
        }
    }, []);
    useWindowEvent('message', (messageEvent: any) => {
        lazyHandleSocPostMessageEvents.importAndExecute(messageEvent);
        if (isSupportEnabled()) {
            lazyHandleSupportPaneEvents.importAndExecute(messageEvent);
        }
    });

    const feedbackNavLink = createHelpLink('OwaFeedbackLink', loc(feedbackLink), undefined, () => {
        lazyLaunchInAppFeedback.importAndExecute();
        return false;
    });

    const helpNavLink = createHelpLink(
        'OwaHelpLink',
        loc(helpLink),
        'https://go.microsoft.com/fwlink/?linkid=853225'
    );

    const privacyNavLink = createHelpLink(
        'OwaPrivacyLink',
        loc(privacyLink),
        'https://go.microsoft.com/fwlink/?linkId=521839'
    );

    const legalNavLink = createHelpLink(
        'OwaTermsLink',
        loc(termsLink),
        'https://www.microsoft.com/en-us/servicesagreement'
    );

    /**
     * When the UserThemeId is set to 'base', the Shell uses an AppBrandTheme palette, if provided.
     * This will be taken from the OWA theme definition with Id 'base'.
     */
    const isShadowMailbox = React.useRef(getUserConfiguration().SessionSettings.IsShadowMailbox);
    const owaChatEnabled = React.useRef(
        !(
            isFeatureEnabled('fwk-partner-code-off') ||
            isFeatureEnabled('fwk-skypeSuite') ||
            isFeatureEnabled('fwk-teamsSuite')
        ) &&
            (isFeatureEnabled('fwk-skypeBusinessV2') || isFeatureEnabled('fwk-skypeConsumer')) &&
            !isShadowMailbox.current
    );
    const headerChatEnabled = React.useRef(
        isFeatureEnabled('fwk-skypeSuite') &&
            (isFeatureEnabled('fwk-skypeBusinessV2') || isFeatureEnabled('fwk-skypeConsumer'))
    );

    const headerTeamsChatEnabled = React.useRef(isFeatureEnabled('fwk-teamsSuite'));
    /**
     * Register for Skype notifications when SWC is initialized.
     *
     * @private
     * @memberof OwaSuiteHeader
     */
    const onSwcCoreReady = (): void => {
        window.removeEventListener('swc:core:ready', () => {
            onSwcCoreReady();
        });
        if (window.swc) {
            window.swc.API.registerEvent(
                'receivedNotification',
                lazyOnNotificationReceived.importAndExecute
            );
            window.swc.API.registerEvent(
                'hideNotification',
                lazyOnHideNotificationReceived.importAndExecute
            );
            if (isSkypeInTabsEnabled()) {
                // 1) Pass in ParallelView = false
                window.swc.API.registerEvent('ready', function () {
                    window.swc.shared.app.isParallelView = false;
                });
                // 2) Recents proxy
                window.swc
                    .getRecents()
                    .then(recentsProxy => recentsProxy.setOptions({ PreventOpenChat: true }));
                // 3) On recents selected
                window.swc.API.registerEvent('onRecentItemSelected', function (id: string) {
                    dispatch(addChatTab(id));
                });
            }
        }
    };

    const getNavBarData = (): ShellNavBarData | null => {
        const owaNavBarData: ShellNavBarData = getBposNavBarData() as ShellNavBarData;
        if (owaNavBarData) {
            const navBarData: ShellNavBarData = {
                ...owaNavBarData,
                CurrentMainLinkElementID: ShellMailId,
                ThemeDataOverride: createThemeData(),
                AppBrandTheme: APP_BRAND_THEME,
                FeedbackLink: feedbackNavLink,
                HelpLink: helpNavLink,
                PrivacyLink: privacyNavLink,
                LegalLink: legalNavLink,
                CurrentWorkloadHelpSubLinks: getWorkloadHelpSublinks(
                    owaNavBarData.CurrentWorkloadHelpSubLinks
                ),
            };
            return navBarData;
        } else {
            return null;
        }
    };
    const createCustomLayout = (): ShellLayout => {
        const customHeaderButtons: ShellControl[] = [];
        const { renderSearch, renderSearchScopePicker, searchBoxRespond } = props;

        pushOnCondition(
            customHeaderButtons,
            OwaMeetNowButton,
            isFeatureEnabled('fwk-meetNowButtonHeader') &&
                lazyIsMeetNowEnabled.tryImportForRender()?.()
        );

        pushOnCondition(
            customHeaderButtons,
            isFeatureEnabled('fwk-skypeBusinessV2') ? OwaBusinessChatButton : OwaConsumerChatButton,
            owaChatEnabled.current
        );

        pushOnCondition(
            customHeaderButtons,
            { id: 'owaChatButton', nativeControlID: 'ChatIcon' } as ShellControl,
            headerChatEnabled.current || headerTeamsChatEnabled.current
        );

        pushOnCondition(
            customHeaderButtons,
            OwaPremiumButton,
            getUserConfiguration().SessionSettings.IsPremiumConsumerMailbox &&
                isFeatureEnabled('auth-leftNavPremiumUpsell') &&
                !isShadowMailbox.current
        );

        if (isFeatureEnabled('inboxForMe-owa-panel')) {
            pushOnCondition(customHeaderButtons, OwaInboxForMeButton);
        }

        if (isFeatureEnabled('honeybee-sidePanel')) {
            pushOnCondition(customHeaderButtons, OwaVaultButton);
            initializeVaultInfoLazy.importAndExecute();
        }

        // Push button standard header button if flight is enabled
        pushOnCondition(
            customHeaderButtons,
            OwaNoteFeedButtonPaid,
            isFeatureEnabled('notes-noteFeedSidePanel') && !isOutlookHosted
        );

        // Push charm button which does delay checking for Samsung notes for users with ads.
        if (
            !isOutlookHosted &&
            !isFeatureEnabled('notes-noteFeedSidePanel') &&
            isConsumer() &&
            !getUserConfiguration().SessionSettings.IsPremiumConsumerMailbox
        ) {
            pushOnCondition(customHeaderButtons, OwaNoteFeedButtonAds);
            lazyInitializeOneNoteFeed.importAndExecute();
        }

        if (isTimePanelAvailable()) {
            pushOnCondition(customHeaderButtons, OwaTimePanelButton);
            lazyInitializeTimePanel.importAndExecute();
        }

        if (isFeatureEnabled('auth-activityFeed')) {
            pushOnCondition(customHeaderButtons, OwaActivityFeedButton);
            setShellButtonCustomBadgeCount(OwaActivityFeedButtonID, getUnseenItemsCount());
        }

        pushOnCondition(customHeaderButtons, OwaSettingsButton);

        if (!isEnvironmentAirGap()) {
            pushOnCondition(customHeaderButtons, OwaShellHelpButton);
        }

        if (isSupportEnabled()) {
            pushOnCondition(customHeaderButtons, OwaSupportButton);
        }

        if (isFeatureEnabled('fwk-feedbackCharm')) {
            pushOnCondition(customHeaderButtons, OwaFeedbackButton);
            if (isFeatureEnabled('fwk-knownIssues')) {
                // Update badge count when known issues state changes.
                const getKnownIssuesBadgeCount = lazyGetKnownIssuesBadgeCount.tryImportForRender();
                const knownIssuesBadgeCount = getKnownIssuesBadgeCount?.();
                setShellButtonCustomBadgeCount(OwaFeedbackButtonID, knownIssuesBadgeCount);
            }
        }

        pushOnCondition(
            customHeaderButtons,
            OwaRolloutOverridesButton,
            isFeatureEnabled('fwk-devTools')
        );

        if (!isOutlookHosted && (getApp() === 'Mail' || getApp() === 'Calendar')) {
            // Only push whats new for mail and calendar because they are the only supported apps
            pushOnCondition(customHeaderButtons, OwaWhatsNewButton);
            setShellButtonCustomBadgeCount(OwaWhatsNewButtonID, getUnreadWhatsNewCardCount());
        }

        pushOnCondition(
            customHeaderButtons,
            OwaDiagnosticsButton(props.DiagnosticsPanel),
            isFeatureEnabled('fwk-devTools') && !!props.DiagnosticsPanel
        );

        // Now define responsive behavior for all the custom header buttons, with the
        // right-most one getting dropped first
        customHeaderButtons.forEach((control, index, array) => {
            if (!control.responsiveBehavior) {
                control.responsiveBehavior = {
                    responsivePriority: array.length - 1 - index + 2,
                    minimizeBehavior: 'overflow',
                    delayMinimize: false,
                };
            } else if (control.responsiveBehavior.responsivePriority == 0) {
                // Update the responsive priorities for the buttons as per its position in the collection
                control.responsiveBehavior.responsivePriority = array.length - 1 - index + 2;
            }
        });
        let leftCharms = [
            {
                id: 'owaBranding',
                flex: renderSearchScopePicker ? '1 1 auto' : '',
                nativeControlID: 'O365Branding',
                minWidth: 'auto',
            } as ShellControl,
        ];

        if (isOutlookHosted) {
            leftCharms.pop();
        } else {
            leftCharms.unshift({
                id: 'tenantLogo',
                nativeControlID: 'TenantLogo',
                minWidth: 'auto',
            } as ShellControl);
        }

        const leftCharmsWidth =
            (props.searchAlignmentWidth /* getSearchBoxLeftPadding */ ||
                getUserConfiguration().UserOptions.NavigationBarWidth) -
            (isOutlookHosted ? 0 : 48); /* Subtract the button width */
        if (renderSearchScopePicker) {
            leftCharms.push({
                id: OWA_SEARCH_SCOPE_PICKER_ID,
                flex: '1 1 auto',
                justifyContent: 'flex-end',
                minWidth: 'auto',
                render: (container: HTMLDivElement) =>
                    ReactDOM.render(renderSearchScopePicker(), container),
            } as ShellControl);
        }
        const layout = {
            enableResponsive: !!props.enableResponsiveLayout,
            leftCustomizationRegion: {
                includeAppLauncher: !isOutlookHosted,
            },
            centerCustomizationRegion: {
                alignItems: 'center',
                flex: '1 0 auto',
                children: [
                    {
                        /* Left aligned */
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        flex: '1 0 auto',
                        children: [
                            {
                                /* Left Charms */
                                children: leftCharms,
                                flex: '0 0 auto',
                                minWidth: `${leftCharmsWidth}px`,
                            } as CustomizationRegion,
                            {
                                /* Search Box */
                                id: 'owaSearchBox',
                                flex: '1 0 auto',
                                render: (container: HTMLDivElement) =>
                                    ReactDOM.render(renderSearch?.(), container),
                                respond: (step: number) => searchBoxRespond?.(step),
                                responsiveBehavior: {
                                    responsivePriority: 1,
                                    minimizeBehavior: 'custom',
                                    delayMinimize: true,
                                    responsiveSteps: [DEFAULT_COLLAPSED_WIDTH],
                                },
                            } as ShellControl,
                        ],
                    } as CustomizationRegion,
                    {
                        /* Menu Buttons - Right aligned */
                        regionID: HEADER_BUTTONS_REGION_ID,
                        flex: '0 0 auto',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                        children: [
                            ...customHeaderButtons,
                            {
                                id: 'OwaMergedNotificationPane',
                                render: (container: HTMLDivElement) =>
                                    ReactDOM.render(getMergedNotificationPane(), container),
                            } as ShellControl,
                        ],
                    } as CustomizationRegion,
                ],
            } as CustomizationRegion,
            rightCustomizationRegion: {
                includeMeControl: true,
                id: 'O365_HeaderRightRegion2',
            },
            flexPaneCollection: [
                OwaFeedbackFlexPane,
                OwaRolloutOverridesFlexPane,
                OwaSettingsFlexPane,
                OwaWhatsNewFlexPane,
                OwaHelpFlexPane,
                OwaSupportFlexPane,
                OwaTimePanelFlexPane,
                OwaActivityFeedFlexPane,
                OwaExpressionFlexPane,
                OwaSkypeFlexPane,
                OwaVaultFlexPane,
                OwaIdeasFlexPane,
                OwaNoteFeedFlexPane,
                OwaInboxForMeFlexPane,
            ],
        } as ShellLayout;
        return layout;
    };

    const createMeSublinks = (): NavBarLinkData[] => {
        return !props.hideOpenAnotherMailbox &&
            getUserConfiguration().SessionSettings.WebSessionType === WebSessionType.Business
            ? [
                  {
                      Id: 'OwaOpenTargetMailboxLink',
                      Text: loc(openAnotherMailbox),
                      Url: 'javascript:void(0)',
                      Action: showOpenAnotherMailboxDialog,
                  },
              ]
            : [];
    };
    const getUserPrincipalName = () => {
        return isShadowMailbox.current
            ? getUserConfiguration().SessionSettings.UserEmailAddress
            : getUserConfiguration().SessionSettings.UserPrincipalName;
    };

    // VSO# 98272: The accountSwitchingSignInUrl will be updated once this is done
    const accountSwitchingSignInUrl = 'https://outlook.live.com/';
    const replyToUrl = `${window.location.origin}${getConfig().baseUrl}/`;
    const appSignOutUrl = `${replyToUrl}logoff.owa`;
    const culture = getUserConfiguration().SessionSettings.UserCulture;

    const suiteHeader = (
        <SuiteHeader
            onLinkClick={onLinkClick}
            culture={culture}
            language={getUserConfiguration().SessionSettings.UserLanguage}
            isRTL={getUserConfiguration().SessionSettings.IsUserCultureRightToLeft}
            isConsumer={isConsumer()}
            userDisplayName={getUserConfiguration().SessionSettings.UserDisplayName}
            userPrincipalName={getUserPrincipalName()}
            workloadID={'Exchange'}
            appBrandTheme={APP_BRAND_THEME}
            currentMainLinkElementID={ShellMailId}
            themeData={createThemeData()}
            customLayout={createCustomLayout()}
            meSublinks={createMeSublinks()}
            shellAssetsContainerOverride={`${urlResolve(
                getPackageBaseUrl(),
                'resources/suiteux-shell'
            )}`}
            navBarData={getNavBarData()}
            onSignOut={signout_0}
            onFlexPaneVisibilityChanged={flexPaneVisiblityChanged}
            helpSublinks={props.MAXHelpDisabled ? props.helpSublinks : undefined}
            shellDataOverrides={{
                SuiteServiceUrl: `${window.location.origin}${getConfig().baseUrl}/service.svc`,
                HideMyProfileLink: isShadowMailbox.current,
                HideMyAccountLink: isShadowMailbox.current,
                AppHeaderLinkText: props.AppHeaderLinkText,
                AppHeaderLinkUrl: props.AppHeaderLinkUrl,
                MAXHelpEnabled: !props.MAXHelpDisabled,
                FeedbackLink:
                    isFeatureEnabled('core-feedback') && !isEnvironmentAirGap()
                        ? feedbackNavLink
                        : undefined,
                HelpLink: props.MAXHelpDisabled ? helpNavLink : undefined,
                UniversalMeControlEnabled: isFeatureEnabled('fwk-meControl'),
                SocHelpUrl: isConsumer()
                    ? 'https://support.office.live.com'
                    : 'https://support.office.com',
                AccountSwitchingEnabled: isFeatureEnabled('auth-meControl-accountSwitcher'),
                // DO NOT OVERRIDE PrivacyLink and LegalLink here.
            }}
            shellAuthProviderConfig={
                {
                    type: 'webDualStack',
                    login_Hint: getUserConfiguration().SessionSettings.UserEmailAddress,
                    appSignInUrl: accountSwitchingSignInUrl,
                    appSignInToUrl: accountSwitchingSignInUrl,
                    appSignOutUrl: appSignOutUrl,
                    appSwitchUrl: accountSwitchingSignInUrl,
                    appSwitchToUrl: accountSwitchingSignInUrl,
                    aad: {
                        wreply: appSignOutUrl,
                        appId: OWA_APP_ID,
                        signOutUrl: `https://login.microsoftonline.com/uxlogout?shouldForgetUser=false&wreply=${appSignOutUrl}&appid=${OWA_APP_ID}`,
                        signOutAndForgetUrl: `https://login.microsoftonline.com/uxlogout?shouldForgetUser=true&wreply=${appSignOutUrl}&appid=${OWA_APP_ID}`,
                        /* Note that passing the replyToUrl is a temporary fix until the MeControl implements idpproxy */
                        rememberedAccountsUrl: `https://login.microsoftonline.com/savedusers?wreply=${replyToUrl}&appid=${OWA_APP_ID}`,
                        forgetUrl: 'https://login.microsoftonline.com/forgetuser',
                    },
                    msa: {
                        wreply: appSignOutUrl,
                        siteId: OWA_CONSUMER_APP_ID,
                        signOutAndForgetUrl: `https://login.live.com/logout.srf?id=${OWA_CONSUMER_APP_ID}&ru=${appSignOutUrl}&mkt=${culture}`,
                        /* Note that passing the replyToUrl is a temporary fix until the MeControl implements idpproxy */
                        rememberedAccountsUrl: `https://login.live.com/Me.srf?wa=wsignin1.0&id=${OWA_CONSUMER_APP_ID}&wreply=${replyToUrl}`,
                    },
                } as any
            }
            renderedCallback={renderedCallback}
            supportShyHeaderMode={isFeatureEnabled('fwk-shy-suiteHeader')}
            getAccessTokenforResource={headerChatEnabled.current ? getToken : null}
            disableToasts={true} // This will turn off suite header toasts
            userID={getUserConfiguration().SessionSettings.UserPuid}
            helpNamespace={
                isConsumer()
                    ? isFeatureEnabled('help-rave-tickets')
                        ? 'OLWACB'
                        : 'OLWAC'
                    : undefined
            }
            workloadContext={`MetaOsRailEnabled:${isFeatureEnabled('tri-metaOsRail')}`}
        />
    );

    const wrapSuiteHeader = props.wrapSuiteHeader;
    if (wrapSuiteHeader) {
        return <>{wrapSuiteHeader(suiteHeader)}</>;
    } else {
        return <div tabIndex={-1}>{suiteHeader}</div>;
    }
});

function renderedCallback() {
    return owaSuiteHeaderRendered();
}

/**
 * @ToDo : Please edit this method appropriately.
 *
 * @private
 * @param {string} resourceAudience
 * @returns {Promise<string>}
 * @memberof OwaSuiteHeader
 */
async function getToken(resourceAudience: string): Promise<string> {
    return await lazyGetAccessTokenforResource.importAndExecute(resourceAudience);
}

function onLinkClick(data: LinkClickEventArgs) {
    if (data && data.Id == 'Calendar') {
        logCalendarUsage('ModuleSwitchToCalendar', {
            source: 'mailWaffle',
        });
    }
}

function signout_0(eventArgs: SignOutEventArgs) {
    eventArgs.triggerEvent.preventDefault();
    lazySignout.importAndExecute(location);
}

function flexPaneVisiblityChanged(isVisible: boolean, props: FlexPaneChangeListenerProperties) {
    setAppPaneUnderlayVisibility('suiteFlexPane', isVisible, true /* isShrinkable */);
}

function pushOnCondition(
    controlCollection: ShellControl[],
    control: ShellControl,
    condition?: boolean
) {
    if (condition === undefined || condition) {
        controlCollection.push(control);
    }
}

function generateSuitePaletteFromFabricPalette(palette: OwaPalette) {
    return {
        LighterAlt: palette.themeLighterAlt,
        Darker: palette.themeDarker,
        Dark: palette.themeDark,
        DarkAlt: palette.themeDarkAlt,
        Light: palette.themeLight,
        Primary: palette.themePrimary,
        Secondary: palette.themeSecondary,
        Tertiary: palette.themeTertiary,
        Lighter: palette.themeLighter,
        NavBar: palette.headerBackground,
        DefaultText: palette.headerTextIcons,
        DefaultBackground: palette.headerButtonsBackground,
        HoverBackground: palette.headerButtonsBackgroundHover,
        AppName: palette.headerBrandText,
        SearchNavBar: palette.headerBackgroundSearch,
        SearchHoverBackground: palette.headerButtonsBackgroundSearchHover,
        SearchAccent: palette.headerBadgeBackground,
    };
}

function createHelpLink(
    id: string,
    helpText: string,
    url?: string,
    action?: () => void
): NavBarLinkData {
    return {
        Id: id,
        Text: helpText,
        Url: url,
        TargetWindow: '_blank',
        Action: action,
    } as NavBarLinkData;
}

function showOpenAnotherMailboxDialog() {
    const [modalPromise] = showModal(OpenAnotherMailboxDialog);
    modalPromise.then(targetMailbox => {
        if (targetMailbox && targetMailbox.length > 0) {
            window.open(getNewScope(targetMailbox), '_blank');
        }
    });
}

function getWorkloadHelpSublinks(originalLinks: NavBarLinkData[]): NavBarLinkData[] {
    if (isWorkloadSupported(OwaWorkload.Calendar)) {
        originalLinks = (originalLinks || []).concat([
            createHelpLink(
                'OwaCalendarAbuseLink',
                loc(reportCalendarAbuseLink),
                'https://www.microsoft.com/concern/calendarabuse'
            ),
        ]);
    }
    return originalLinks;
}

function createThemeData(): ThemeDataOverride {
    const themeId: string = getCurrentThemeId();
    const themeData: ThemeDataOverride = {
        UserPersonalizationAllowed: isUserPersonalizationAllowed(),
        IsDarkTheme: getIsDarkTheme(),
        UserThemeId: themeId,
        ...(!isFeatureEnabled('fwk-suiteThemes')
            ? {
                  PreferOfficeTheme: themeId === ThemeConstants.BASE_OFFICE_THEME_ID,
                  UserThemePalette: {
                      ...generateSuitePaletteFromFabricPalette(getPaletteAsRawColors(themeId)),
                      ...getHeaderImageData(themeId),
                  },
                  TenantThemePalette: generateSuitePaletteFromFabricPalette(
                      getCobrandingThemeResources().themePalette
                  ),
              }
            : {
                  PreferOfficeTheme: getIsOfficeThemePreferred(),
                  UserThemePalette: getCurrentTheme(),
                  TenantThemePalette: generateSuitePaletteFromFabricPalette(
                      getCobrandingThemeResources().themePalette
                  ),
              }),
    } as ThemeDataOverride;
    return themeData;
}
